import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  NumberInput
} from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxAsthmaSettingsData {
  alerts: boolean;
  afterHourInfo: boolean;
  thresholds: {
    rescueInhalerUses: {
      extreme: number;
      high: number;
      medium: number;
    };
    weeklyRescueInhalerUses: {
      high: number;
      medium: number;
    };
    weeklyTimesAwakened: {
      high: number;
    };
  };
}

const DefaultSettings: EpxAsthmaSettingsData = {
  alerts: true,
  afterHourInfo: false,
  thresholds: {
    rescueInhalerUses: {
      extreme: 10,
      high: 3,
      medium: 1
    },
    weeklyRescueInhalerUses: {
      high: 2,
      medium: 1
    },
    weeklyTimesAwakened: {
      high: 1
    }
  }
};

interface EpxAsthmaSettingsProps {
  setForm?: (form: FormInstance<EpxAsthmaSettingsData>) => void;
  onSubmit?: (data: EpxAsthmaSettingsData) => void;
  disabled?: boolean;
}

const EpxAsthmaSettings = ({
  setForm,
  onSubmit,
  disabled
}: EpxAsthmaSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxAsthmaSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Daily Rescue Inhaler Uses - Extreme"
                name="thresholds.rescueInhalerUses.extreme"
                required
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Daily Rescue Inhaler Uses - High"
                name="thresholds.rescueInhalerUses.high"
                required
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Daily Rescue Inhaler Uses - Medium"
                name="thresholds.rescueInhalerUses.medium"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Weekly Rescue Inhaler Uses - High"
                name="thresholds.weeklyRescueInhalerUses.high"
                required
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Weekly Rescue Inhaler Uses - Medium"
                name="thresholds.weeklyRescueInhalerUses.medium"
                required
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <NumberInput
                label="Weekly Times Awakened By Symptoms Threshold"
                name="thresholds.weeklyTimesAwakened.high"
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxAsthmaSettings;
